module.exports = __webpack_public_path__ + "img/bedroom-rugs-runners.a870141.jpg";